import React from 'react';
import { CreateCustomerState } from './createCustomerState/CreateCustomerState';
import { ModalWindows } from './components/ModalWindows';
import Form from './components/Form/Form';

const CreateCustomerPage: React.FC = () => {
	return (
		<CreateCustomerState>
			<Form />
			<ModalWindows />
		</CreateCustomerState>
	);
};

export default CreateCustomerPage;
